import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { CHART_COLORS } from '../../utils/rollup';
import { fmtMoney } from './format';
import Panel from './Panel';
import ShareList from './ShareList';

export default function TimeByEmployeePie({ data }) {
  return (
    <Panel title="Time by Employee" empty={!data?.length} emptyText="No employee time data">
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ width: 300, height: 300 }}>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data} dataKey="amount" nameKey="name"
                cx="50%" cy="50%" innerRadius={35} outerRadius={70} paddingAngle={3}
                label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
                labelLine={false}
              >
                {(data || []).map((entry, i) => (
                  <Cell key={entry.name} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(v) => fmtMoney(v)} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <ShareList data={data} />
      </div>
    </Panel>
  );
}
